module.exports = __webpack_public_path__ + "static/media/HS654HJ.eaaecaa6.jpg";